import React, { Component } from "react";
import StatsBox from "../StatsPage/StatsBox.js";
import InfoTable from "../InfoTable.js";
import ResultInfoText from "../ResultsTable/ResultInfoText.js";
import KingdomIcon from "../ReactionTable/kingdomIcon.js";
import { useState } from "react";
import axios from "../../api/axios.js";
import { useEffect } from "react";
import getDataByEnzymesFromSearchResults from "../../api/transformSearchResultsToEnzymes.js";
import { useParams } from "react-router-dom";
import ReactionResultBox from "../ResultsTable/ReactionResultBox.js";
import translateTerpeneType from "../../api/typeTranslator.js";
import SmallLoading from "../smallLoading.js";
import MoleculesDiv from "../MoleculeTable/MoleculesDiv.js";
import { getUniqueMoleculesFromEnzymesAllInfo, hasUnresolvedMolecule } from "../../api/HelperFunctions.js";
import { groupTypesAndKingdoms } from "../../functions/statisticsDataProcessing.js";
import renderSearchResults from "../../api/renderSearchResults.js";
import MoleculeForm from "../SubmitPage/MoleculeForm.js";
import EnzymeDisplayBox from "../EnzymeDisplayBox.js";
import SubmitInputField from "../SubmitPage/submitInputField.js";
import "./EnzymeStructureFilter.css"; 

function EnzymeBrowser({ setMechBody, navigateToRecord}) {
    const [stats, setStats] = useState(null);
    const [kingdoms, setKingdoms] = useState([]);
    const [selectedTypes, setSelectedTypes] = useState([]);
    const [bannedTypes, setBannedTypes] = useState([]);
    const [selectedClasses, setSelectedClasses] = useState([]);
    const [selectedKingdoms, setSelectedKingdoms] = useState([]);
    const [bannedKingdoms, setBannedKingdoms] = useState([]);
    const [selectedSpecies, setSelectedSpecies] = useState("");
    const [selectedMolecules, setSelectedMolecules] = useState([{ molecule_id: null, smiles: "", name: "", marts: "", chebi: "" }]);
    const [selectedMoleculeName, setSelectedMoleculeName] = useState("");
    const [searchData, setSearchData] = useState({ types: [], kingdoms: [] });

     const handleSpeciesChange = (e) => {
        const value = e.target.value;
        setSelectedSpecies(value);
    }

    const [loading, setLoading] = useState(false);

    // Bumped on every search so the results box remounts and reflects the latest
    // resData. Needed because EnzymeDisplayBox renders its list once on mount; the
    // short-circuit path below sets loading false synchronously (no await), so it
    // would otherwise never unmount/remount and would keep showing stale results.
    const [searchId, setSearchId] = useState(0);


    const [resData, setResData] = useState(null);


    const [reactionsBody, setReactionsBody] = useState(null);


    const [structureExp, setStructureExp] = useState(false);
    const [structurePred, setStructurePred] = useState(false);

    const [structureMethods, setStructureMethods] = useState([]); 
    const [selectedExpMethods, setSelectedExpMethods] = useState([]);   
    const [selectedPredMethods, setSelectedPredMethods] = useState([]);

    const [resMin, setResMin] = useState("");
    const [resMax, setResMax] = useState("");


    const [availableMotifs, setAvailableMotifs] = useState([]);
    const [selectedMotifs, setSelectedMotifs] = useState([]);


  const addMolecule = () => {
    setSelectedMolecules([...selectedMolecules, { molecule_id: null, smiles: "", name: "", marts: "", chebi: "" }]);
  };

  const removeLastMolecule = () => {
    setSelectedMolecules(selectedMolecules.slice(0, -1));
  };
 
    
    function processStats(stats){
    let kingdomsNames = stats.kingdomsCounts.map(k => k.kingdom);
    const typesAndKingdoms = groupTypesAndKingdoms(stats.terpeneTypesByKingdomCount);
    stats.groupedTypesKingdoms = typesAndKingdoms[0];
    setKingdoms(kingdomsNames.sort());
    return stats;
  }

     useEffect(() => {
        if(stats){
            return;
        }
        axios.post("/statspage").then(res => {
          setStats(processStats(res.data));
        });
        handleSearch();
      }, []);

    
    useEffect(() => {
      axios.get("/structuremethods")
        .then(r => setStructureMethods(r.data?.methods || []))
        .catch(() => setStructureMethods([]));
    }, []);

    const toggleSelection = (value, selectedValues, setSelectedValues) => {
    if (selectedValues.includes(value)) {
      setSelectedValues(selectedValues.filter(v => v !== value));
    } else {
      setSelectedValues([...selectedValues, value]);
    }
  };

  const makeTriChoice = (yesArray, setYesArray, noArray, setNoArray) => {
  return (value, choice /* "Y" | "N" | null */) => {
    if (choice === "Y") {
      setYesArray(prev => (prev.includes(value) ? prev : [...prev, value]));
      setNoArray(prev => prev.filter(v => v !== value));
    } else if (choice === "N") {
      setNoArray(prev => (prev.includes(value) ? prev : [...prev, value]));
      setYesArray(prev => prev.filter(v => v !== value));
    } else {
      // null → clear
      setYesArray(prev => prev.filter(v => v !== value));
      setNoArray(prev => prev.filter(v => v !== value));
    }
  };
};

const chooseType = makeTriChoice(selectedTypes, setSelectedTypes, bannedTypes, setBannedTypes);
const chooseKingdom = makeTriChoice(selectedKingdoms, setSelectedKingdoms, bannedKingdoms, setBannedKingdoms);

const toggleExp = () => { 
  setStructureExp(prev => !prev); 
}
const togglePred = () => {
  setStructurePred(prev => {
    const next = !prev;
    if (!next) {
      setSelectedExpMethods([]);
      setSelectedPredMethods([]);
    }
    return next;
  });
};

const resetStructureFilters = () => {
  setStructureExp(false);
  setStructurePred(false);
  setSelectedExpMethods([]);
  setSelectedPredMethods([]);
  setResMin("");
  setResMax("");
};

    useEffect(() => {
     
     axios.get("/motifs")
       .then(r => setAvailableMotifs(r.data?.motifs || []))
       .catch(() => setAvailableMotifs([]));
   }, []);

    async function handleSearch() {
      setLoading(true);
      setSearchId(id => id + 1);

     // If any molecule row has a typed identifier that never resolved to a MARTS
     // molecule, the filter cannot match anything — show no enzymes rather than
     // silently dropping the filter and returning everything (see helper).
     if (hasUnresolvedMolecule(selectedMolecules)) {
       setResData([]);
       setLoading(false);
       return;
     }

     const nameMap = {};
     structureMethods.forEach(m => {
       nameMap[m.method_id] = (m.method_name || "").toLowerCase();
     });
     const selectedNamesExp = selectedExpMethods.map(id => nameMap[id]);
     const selectedNamesPred = selectedPredMethods.map(id => nameMap[id]);
     const allSelectedNames = [...selectedNamesExp, ...selectedNamesPred];

     const legacyMethods = {
       xray: allSelectedNames.some(n => n === "x-ray diffraction" ),
       cryo_em: allSelectedNames.some(n => n === "cryo-em"),
       alphafold: allSelectedNames.some(n => n === "alphafold"),
       esmfold: allSelectedNames.some(n => n === "esmfold")
     };

     
      const res = await axios.post("/basicsearch", {
        allEnzymeReactions: true,
        types: selectedTypes,
        kingdoms: selectedKingdoms,
        classes: selectedClasses,
        noTypes: bannedTypes,
        noKingdoms: bannedKingdoms,
        species: selectedSpecies.trim() !== "" ? [selectedSpecies.trim()] : [],
        mol_names: [
          ...selectedMolecules
            .filter(mol => mol.name && mol.name.trim() !== "")
            .map(mol => mol.name),
          ...(selectedMoleculeName.trim() !== "" ? [selectedMoleculeName.trim()] : [])
        ],
        molecules: selectedMolecules
          .filter(mol => mol.marts && mol.marts.trim() !== "")
          .map(mol => mol.marts),
        motifs: selectedMotifs,
        structure: {
          experimental: structureExp,
          predicted: structurePred,
          methods: legacyMethods,
        
          resolution: {
            min: resMin === "" ? null : Number(resMin),
            max: resMax === "" ? null : Number(resMax)
          }
        }
      });
      const reactionsData = getDataByEnzymesFromSearchResults(res.data);
      const renderedReactions = renderSearchResults({table: reactionsData, setMechBody, isQuickSearch: true, interactiveSearch:() => {}, dataProcessed: true, navigateToRecord: navigateToRecord});
      //setReactionsBody(renderedReactions);
      setResData(reactionsData);
      setLoading(false);
    }

    if (!stats){
        return <StatsBox title="Loading enzymes..."><SmallLoading /></StatsBox>;
    }
    return (
        <>

        <StatsBox title="Enzyme filters" hide={true}>
<StatsBox title="Terpene types">
            <div className="checkboxes-div">
            {stats.terpenesByType.map(t => (
              <label key={t.type} className="basic-checkbox">
                <input
                  type="checkbox"
                  className="basic-checkbox-box"
                  checked={selectedTypes.includes(t.type)}
                  onChange={() => toggleSelection(t.type, selectedTypes, setSelectedTypes)}
                />
                <span >{translateTerpeneType(t.type)}</span>
              </label>          
            ))}
            </div>
          </StatsBox>
          <StatsBox title="Reaction classes">
            <div className="checkboxes-div">
            {[1, 2].map(cls => (
              <label key={cls} className="basic-checkbox">
                <input
                  type="checkbox"
                  className="basic-checkbox-box"
                  checked={selectedClasses.includes(cls)}
                  onChange={() => toggleSelection(cls, selectedClasses, setSelectedClasses)}
                />
                <span>Class {cls == 1 ? "I" : "II"}</span>
              </label>
            ))}
            </div>
          </StatsBox>

          <StatsBox title="Origin kingdoms">
            <div className="checkboxes-div">
            {kingdoms.map(k => (
              <label key={k} className="basic-checkbox">
                <input
                  type="checkbox"
                  className="basic-checkbox-box"
                  checked={selectedKingdoms.includes(k)}
                  onChange={() => toggleSelection(k, selectedKingdoms, setSelectedKingdoms)}
                />
                <span>{k}</span>
              </label>
            ))}
           </div> 
          </StatsBox>

              <StatsBox title="Origin species">
            <div>
              <SubmitInputField name="nameSpecies" value={selectedSpecies} onChange={handleSpeciesChange} label="Species name" disabled={false} tooltip={"Enter part of the desired species name"} placeholder="Arabidopsis thaliana"/>
            </div>

          </StatsBox>

        <StatsBox title="Molecules">
            <p>Products or substrates of desired enzymes. Molecules are either searched by similar names or exactly by marts, when other fields are filled, MARTS will be filled in automatically.</p>
            
            <SubmitInputField
              name="moleculeNameLike"
              value={selectedMoleculeName}
              onChange={(e) => setSelectedMoleculeName(e.target.value)}
              label="Molecule name (fuzzy)"
              disabled={false}
              tooltip="Find enzymes with any substrate or product whose name matches this substring. Combined with the molecules below using OR."
              placeholder="e.g. germacrene"
            />
            {selectedMolecules.map((mol, index) => (
              <MoleculeForm key={index}
              title_text={`Molecule`}
              molecule={mol}
              onChange={(updatedMolecule) =>  setSelectedMolecules(selectedMolecules.map((s, i) => (i === index ? updatedMolecule : s)))}
              disabled={false}
            moleculeId_start={mol.molecule_id}
            tooltips={{smiles: "Enter the SMILES of the desired molecule. If a molecule described by this SMILES exists in the database, MARTS ID will be filled in.", name: "Enter the name of the molecule as saved in MARTS. If it exists MARTS ID will be filled.", chebi: "Enter the ID of the molecule in ChEBI database. If it exists in the databse MARTS ID will be filled.",
              marts: "Enter the MARTS ID, the molecule will be searched based on MARTS."
            }}/>
            ))
            }
            <button className="basic-button" onClick={addMolecule}>Add molecule</button>
            <button className="basic-button" onClick={removeLastMolecule} >Remove molecule</button>
          </StatsBox>


        <StatsBox title={"Structure"}>
          <div className="ez-struct-filter">
            <div className="ez-group">
              <div className="ez-title">Type</div>
              <div className="ez-row">
                <button
                  type="button"
                  onClick={toggleExp}
                  className={`basic-button ez-toggle ${structureExp ? 'active' : ''}`}
                  title="Experimental structures"
                >
                  Experimental
                </button>
                <button
                  type="button"
                  onClick={togglePred}
                  className={`basic-button ez-toggle ${structurePred ? 'active' : ''}`}
                  title="Predicted structures"
                >
                  Predicted
                </button>
                <button
                  type="button"
                  className="ez-reset"
                  onClick={resetStructureFilters}
                  title="Reset structure filters"
                >
                  Reset
                </button>
              </div>
              <div className="ez-help">Leave both off to ignore this filter.</div>
            </div>

            {structureExp && <>
            <div className="ez-divider" />

            <div className="ez-group">
              <div className="ez-title">Experimental methods</div>
              <div className="ez-row" style={{flexWrap:"wrap", gap:8}}>
                {structureMethods
                  .filter(m => {
                    const n = m.method_name.toLowerCase();
                    return ["x-ray diffraction","x-ray","cryo-em","nmr"].includes(n);
                  })
                  .map(m => {
                    const active = selectedExpMethods.includes(m.method_id);
                    return (
                      <button
                        key={m.method_id}
                        type="button"
                        onClick={() => {
                          setSelectedExpMethods(prev =>
                            active ? prev.filter(id => id !== m.method_id)
                                   : [...prev, m.method_id]);
                        }}
                        className={`basic-button ez-toggle ${active ? "active" : ""}`}
                        title={m.method_name}
                      >
                        {m.method_name}
                      </button>
                    );
                  })}
              </div>
              <div className="ez-grid-2">
                <label className="ez-field">
                  <span className="ez-label">Min res (Å)</span>
                  <input
                    type="number"
                    step="0.01"
                    className="basic-input"
                    value={resMin}
                    onChange={e => setResMin(e.target.value)}
                    placeholder="1.5"
                  />
                </label>
                <label className="ez-field">
                  <span className="ez-label">Max res (Å)</span>
                  <input
                    type="number"
                    step="0.01"
                    className="basic-input"
                    value={resMax}
                    onChange={e => setResMax(e.target.value)}
                    placeholder="2.0"
                  />
                </label>
              </div>
            </div>
            </>}

            {structurePred && <>
            <div className="ez-divider" />

            <div className="ez-group">
              <div className="ez-title">Predicted methods</div>
              <div className="ez-row" style={{flexWrap:"wrap", gap:8}}>
                {structureMethods
                  .filter(m => {
                    const n = m.method_name.toLowerCase();
                    return ["alphafold","esmfold"].includes(n);
                  })
                  .map(m => {
                    const active = selectedPredMethods.includes(m.method_id);
                    return (
                      <button
                        key={m.method_id}
                        type="button"
                        onClick={() => {
                          setSelectedPredMethods(prev =>
                            active ? prev.filter(id => id !== m.method_id)
                                   : [...prev, m.method_id]);
                        }}
                        className={`basic-button ez-toggle ${active ? "active" : ""}`}
                        title={m.method_name}
                      >
                        {m.method_name}
                      </button>
                    );
                  })}
              </div>
          
            </div>
            </>}
          </div>
        </StatsBox>

        <StatsBox title="Motifs">

          <div className="checkboxes-div">
            {availableMotifs.map(m => (
              <label key={m.motif_id} className="basic-checkbox">
                <input
                  type="checkbox"
                  className="basic-checkbox-box"
                  checked={selectedMotifs.includes(m.name)}
                  onChange={() => {
                    if (selectedMotifs.includes(m.name)) {
                      setSelectedMotifs(selectedMotifs.filter(x => x !== m.name));
                    } else {
                      setSelectedMotifs([...selectedMotifs, m.name]);
                    }
                  }}
                />
                <span>{m.name}</span>
              </label>
            ))}
          </div>
        </StatsBox>




          <button
            className="basic-button"
            onClick={() => handleSearch()}
          >
            Display selected
          </button>
  
        </StatsBox>




        <StatsBox title={"Enzymes"}>
            { loading ? <SmallLoading /> :
            <div>
              <div style={{ display: "flex", justifyContent: "center" }}>Found {resData.length} enzymes</div>
            <EnzymeDisplayBox key={searchId} reactionsDataByEnzymes={resData} setMechBody={setMechBody} navigateToRecord={navigateToRecord} isQuickSearch={true} interactiveSearch={() => {}} startingDisplay={20} displayStep={10}/>
            </div>
            }
        </StatsBox>
    
        </ >
    );

}

export default EnzymeBrowser;